import type { AxiosResponse } from 'axios'
import authApiClient from './axios.interceptor.ts'
import {
  apiBaseUrl,
  apiV3BaseUrl,
  billingBaseUrl,
} from '@/logic/configuration.ts'

type RequestConfig = Parameters<typeof authApiClient.get>[1]

interface API {
  get: <T>(url: string, config?: RequestConfig) => Promise<AxiosResponse<T>>
  post: <T>(
    url: string,
    data: unknown,
    config?: RequestConfig
  ) => Promise<AxiosResponse<T>>
  put: <T>(
    url: string,
    data: unknown,
    config?: RequestConfig
  ) => Promise<AxiosResponse<T>>
  delete: <T>(url: string, config?: RequestConfig) => Promise<AxiosResponse<T>>
  patch: <T>(
    url: string,
    data: unknown,
    config?: RequestConfig
  ) => Promise<AxiosResponse<T>>
}

const makeApiClient = (baseURL: string, client = authApiClient): API => ({
  get: async <T>(url: string, config?: RequestConfig) =>
    await client.get<T>(url, { ...config, baseURL }),
  post: async <T>(url: string, data: unknown, config?: RequestConfig) =>
    await client.post<T>(url, data, { ...config, baseURL }),
  put: async <T>(url: string, data: unknown, config?: RequestConfig) =>
    await client.put<T>(url, data, { ...config, baseURL }),
  delete: async <T>(url: string, config?: RequestConfig) =>
    await client.delete<T>(url, { ...config, baseURL }),
  patch: async <T>(url: string, data: unknown, config?: RequestConfig) =>
    await client.patch<T>(url, data, { ...config, baseURL }),
})

export const apiClient = makeApiClient(apiBaseUrl)
export const apiV3Client = makeApiClient(apiV3BaseUrl)
export const billingClient = makeApiClient(billingBaseUrl)
